import store from "redux/store";
import { Auth } from "aws-amplify";

import { setViewerWebUrl } from "redux/webUrl/action";
import { emptyGameData } from "redux/gameParams/actions";
import { set_sign_in_details } from "redux/signin/action";
import { endGame, setCurrentUser, setGameName } from "redux/game/action";

export const onLogOut = async (password_reset = false) => {
  sessionStorage.clear();
  localStorage.removeItem("utm_medium");
  localStorage.removeItem("utm_source");
  localStorage.removeItem("utm_campaign");
  localStorage.removeItem("utm_content");
  localStorage.removeItem("webUrl");
  localStorage.removeItem("viewer");
  localStorage.removeItem("setwebUrl");
  store.dispatch(setViewerWebUrl(false));
  localStorage.removeItem("temp_utm_source");
  localStorage.removeItem("temp_utm_content");
  localStorage.removeItem("temp_utm_medium");
  localStorage.removeItem("temp_utm_campaign");
  sessionStorage.removeItem("gameCode");
  localStorage.removeItem("work_game");
  localStorage.removeItem("mailId");
  sessionStorage.removeItem("teamCode");
  sessionStorage.removeItem("trailSocialLogin");
  store.dispatch(setGameName(""));
  store.dispatch(endGame(true));
  console.log("outside of signout ");
  store.dispatch(emptyGameData({}));
  store.dispatch(setCurrentUser({}));
  store.dispatch(
    set_sign_in_details({
      sign_up: false,
      sign_up_with_email: password_reset ? true : false
    })
  );
  localStorage.removeItem("auth");
  await Auth.signOut()
    .then((user) => {
      store.dispatch(endGame(true));
      store.dispatch(setCurrentUser({}));
    })
    .catch((err) => {});
};
